<template>
	<small v-if="numberOfItems" class="fw7 c6 fs3">
		{{ pageInfo }}
	</small>
</template>
<script>
export default {
	props: {
		currentPage: Number,
		itemsPerPage: Number,
		numberOfItems: Number
	},

	computed: {
		// Returns what items we are showing in listing based on pagination: "1-50 of 300" etc...
		pageInfo() {
			const from = (this.currentPage - 1) * this.itemsPerPage + 1
			const to =
				this.itemsPerPage * this.currentPage > this.numberOfItems
					? this.numberOfItems
					: this.itemsPerPage * this.currentPage

			return from + "-" + to + ` ${this.$t("of")} ${this.numberOfItems}`
		}
	}
}
</script>
